import { Timestamp } from "firebase/firestore";
import { convertTimestampToDateTime } from "../../utils/ProductStatus";

class Transactions {
    constructor({
        id,
        bill,
        date,
        serialNumbers,
        toEntityId,
        to,
        fromDistributorId,
        
    }) {
        this.id = id
        this.billValue = bill; // Number
        this.createdAt = (date);
        this.productId = id; // Array of strings
        this.retailerId = toEntityId; // String
        this.soldto = to; // String
        this.totalQuantity = serialNumbers.length; // Number
        this.fromDistributorId=fromDistributorId;
    }
}

export default Transactions;
